import { LoadingController, ModalController, NavController } from '@ionic/angular';
import { Component, Input, OnInit } from '@angular/core';

import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;

import htmlToPdfmake from "html-to-pdfmake";

@Component({
  selector: 'app-order-ticket',
  templateUrl: './order-ticket.page.html',
  styleUrls: ['./order-ticket.page.scss'],
})
export class OrderTicketPage implements OnInit {
@Input() set ticket (ticket){
  console.debug('input data ', ticket)
  this._ticket = ticket;

}
@Input() set orden (orden){
  console.debug('input data orden ', orden)
  this._orden = orden;
}
_orden ;

_ticket:any;
has_header : boolean;
has_footer : boolean;
content: string;
imageDefault = ''

bodyElementAndValues = []

  constructor(private loadingCtrl: LoadingController, private navCtrl : NavController, private modalCtrl : ModalController) { }

  async ngOnInit() {
   // this._ticket = ticket ;
    if (this._ticket) {
      this.has_header = this._ticket['header'] ? true : false;
      this.has_footer = this._ticket['footer'] ? true : false;
      
    }
    this.imageDefault = await this.getBase64ImageFromURL("../../../../assets/img/logo_Home.webp");
    this._ticket.logo = this._ticket.logo ?  await this.getBase64ImageFromURL(this._ticket.logo) : this.imageDefault;

    this.bodyElementAndValues = Object.entries(this._ticket.body)
    console.log(this.bodyElementAndValues);
    
  }

  async dowloadPdf(){
    const loading = await this.loadingCtrl.create({
      message: 'Generando Ticket...',
      duration: 2000
    })
    await loading.present();
    
    // var options = {
    //   pageOrientation: 'landscape',
    //   pageMargins: [10, 10, 10, 10],
    //   content: [
    //     {
    //       text: 'Hello world!'
    //     }
    //   ]
    // };
    
    // pdfMake.createPdf(options).download();
    // pdfMake.createPdf(options).open();
    // pdfMake.createPdf(options).print();
    // pdfMake.createPdf(options).update();
    // pdfMake.createPdf(options).getBase64((data) => {
    //   console.log(data);
    // });
    // pdfMake.createPdf(options).getDataUrl((data) => {
    //   console.log(data);
    // });
    // pdf)
     // html2canvas(document.querySelector("#content_ticket")).then(canvas => {
    //  document.body.appendChild(canvas)
        //var data = canvas.toDataURL();
        const element = document.getElementById("content_ticket").innerHTML
        const canva = htmlToPdfmake(element, {
          tableAutoSize:true
        });
      
            var docDefinition = {
              pageMargins: [30, 30, 30, 30],
              content: canva
            }
              
            pdfMake.createPdf(docDefinition).download(`Ticket Orden ${this._orden}`);
  /*  }).finally(()=>{
      console.log('finalize')
      loading.dismiss();
    });
 */
     

    // pdfMake.createPdf(options).download();
  }

  getBase64ImageFromURL(url):Promise<string | any> {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };
      img.onerror = error => {
        reject(error);
      };
      img.src = url;
    });
  }

  isPrice(item){
    return item.includes('$')
  }

  back(){
    this.modalCtrl.dismiss();
  }


}


const ticket =  {
      "header": "Puntored\nCorresponsal Bancario Davivienda.",
      "body": {
        "Fecha": "2021-06-22",
        "Hora": "12:39:26",
        "Aprobación": "117728052",
        "Trace": "030621",
        "Talon": "542760",
        "Comercio": "414333",
        "Terminal": "8000",
        "Usuario de Venta": "207597",
        "Operacion": "Recaudo",
        "Convenio": "ADINTECH SAS",
        "Cod. Convenio": "0000001013499",
        "Referencia 1": "230003461",
        "Referencia 2": "",
        "Valor": "$7,000",
        "Costo Transaccion": "$0",
        "Total": "$7,000"
      },
      "footer": "Aqui tambien puede pagar \nsu tarjeta de credito y creditos de\nconsumo del Banco Davivienda\n\nLínea de atención personalizada: #688\nMensaje de texto: 85888\n\nBANCO DAVIVIENDA S.A.\nVIGILADO SUPERINTENDENCIA \nFINANCIERA DE COLOMBIA",
      "title": "TRANSACCION EXITOSA.",
      "logo": "https://storage.googleapis.com/cxr-portal-img/icons/tirilla/102x96_puntored_daviplata (2).jpg"
   
}
